import { ShimmerTwoCol } from "./DashboardShimmer";
import "./dashboard-sections.css";

const DUMMY = {
  evaporation: { pct_in_maturity: "3.2%", assumed_kg: "1,840", assumed_cases: "92" },
  trash: [
    { label: "Non Trash %",     value: "94.8%", color: "green"  },
    { label: "Trash % Total",   value: "5.2%",  color: "red"    },
    { label: "Processing Only", value: "2.8%",  color: "orange" },
    { label: "Sorting Loss",    value: "2.4%",  color: "orange" },
  ],
};

const LossMetrics = ({ data = DUMMY, isLoading = false }) => (
  <div>
    <div className="db-section-title">
      <span className="db-title-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
        </svg>
      </span>
      Loss Metrics
    </div>
    {isLoading ? (
      <ShimmerTwoCol />
    ) : (
      <div className="db-two-col">
        {/* Evaporation */}
        <div className="db-avg-card">
          <div className="db-avg-header">
            <span className="db-avg-header-title">Evaporation Metrics</span>
            <span className="db-avg-header-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
                <path d="M12 6v6l4 2"/>
              </svg>
            </span>
          </div>
          <div className="db-evap-row">
            <div className="db-evap-box">
              <div className="db-evap-label">% In Maturity</div>
              <div className="db-evap-value">{data.evaporation.pct_in_maturity}</div>
            </div>
            <div className="db-evap-box">
              <div className="db-evap-label">Assumed KG</div>
              <div className="db-evap-value neutral">{data.evaporation.assumed_kg}</div>
            </div>
            <div className="db-evap-box">
              <div className="db-evap-label">Assumed Cases</div>
              <div className="db-evap-value neutral">{data.evaporation.assumed_cases}</div>
            </div>
          </div>
        </div>

        {/* Trash */}
        <div className="db-avg-card">
          <div className="db-avg-header">
            <span className="db-avg-header-title">Trash Metrics</span>
            <span className="db-avg-header-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
              </svg>
            </span>
          </div>
          <div className="db-trash-grid">
            {data.trash.map((t, i) => (
              <div key={i} className="db-trash-cell">
                <span>{t.label}</span>
                <span className={`db-trash-val ${t.color}`}>{t.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    )}
  </div>
);

export default LossMetrics;
